import { render, staticRenderFns } from "./asaoma.vue?vue&type=template&id=4469de38&scoped=true&"
import script from "./asaoma.vue?vue&type=script&lang=js&"
export * from "./asaoma.vue?vue&type=script&lang=js&"
import style0 from "./asaoma.vue?vue&type=style&index=0&id=4469de38&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4469de38",
  null
  
)

export default component.exports